import React from "react";
import PropTypes from "prop-types";

const SelectionCheckbox = ({ row, checked, onSelectionChange }) => {

  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onSelectionChange(row, e.target.checked)}      
    />
  );
};

SelectionCheckbox.propTypes = {
  row: PropTypes.object.isRequired,
  selectedRows: PropTypes.array,
  onSelectionChange: PropTypes.func.isRequired  
};

export default SelectionCheckbox;
